import Skeleton from 'react-loading-skeleton'
import { Path, Svg, View } from '../../compiler'
import { typoStyles } from '../../constants'
import MarkdownText from '../MarkdownText'

const MandatoryCriterion = ({ text, style, isLoading }) => (
  <View
    style={[
      {
        flexDirection: 'row',
        alignItems: 'center'
      },
      style
    ]}
  >
    {isLoading ? (
      <Skeleton width={16} height={17} />
    ) : (
      <Svg
        width='16'
        height='17'
        viewBox='0 0 16 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <Path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2 8.5C2 8.08579 2.33579 7.75 2.75 7.75L11.4393 7.75L8.21967 4.53033C7.92678 4.23744 7.92678 3.76256 8.21967 3.46967C8.51256 3.17678 8.98744 3.17678 9.28033 3.46967L13.7803 7.96967C14.0732 8.26256 14.0732 8.73744 13.7803 9.03033L9.28033 13.5303C8.98744 13.8232 8.51256 13.8232 8.21967 13.5303C7.92678 13.2374 7.92678 12.7626 8.21967 12.4697L11.4393 9.25L2.75 9.25C2.33579 9.25 2 8.91421 2 8.5Z'
          fill='#4461D4'
        />
      </Svg>
    )}
    <MarkdownText style={[typoStyles.T1Black, { marginLeft: 18 }]}>
      {isLoading ? <Skeleton width={200} /> : text}
    </MarkdownText>
  </View>
)
export default MandatoryCriterion
